import { ArrowRightIcon, SignInIcon } from '@primer/octicons-react';
import { ActionList, Box, Checkbox } from '@primer/react';
import React, { useEffect, useMemo, useState } from 'react';
import { hinhThucMienGiamApi } from '../../../api/hinhThucMIenGiamApi';
import { khoanNopGroupTypeApi } from '../../../api/khoanNopGroupTypeApi';
import { saleSetRegisterTypeApi } from "../../../api/saleSetRegisterTypeApi";
import { khoanNopGroupApi } from '../../../api/sf_khoannop_group_api';
import Button from '../../../components/ui/button';
import { NotifyHelper } from '../../../helpers/toast';
import { useCommonSelectedHook } from '../../../hooks/useCommonSelectedHook';
import { IKhoanNopGroup } from '../../../models/response/finance/IKhoanNopGroup';
import { ISaleSetKhoanNopGroupType } from '../../../models/response/finance/ISaleSetKhoanNopGroupType';
import { ISaleSetRegisterType } from "../../../models/response/finance/ISaleSetRegisterType";
import { KhoanNopByHocSinhItemResponse } from '../../../models/response/dich-vu/KhoanNopByHocSinhItemResponse';
interface HinhThucNopPhiProps {
    hocSinh: any;
    onSubmit: (data: boolean) => void;
    onBack: () => void,
    onCancel: () => void,
    isTinhMienGiam: boolean;
}
interface MienGiamItem {
    id: number;
    ma_hinh_thuc: string;
    hinh_thuc_mien_giam: string;
    nhom_mien_giam: string;
}

interface GroupedMienGiam {
    key: string;
    items: MienGiamItem[];
}

interface ApiResponse<T> {
    is_success: boolean;
    data?: T;
    message?: string;
}
const HinhThucNopPhi: React.FC<HinhThucNopPhiProps> = ({ hocSinh, onSubmit, onBack, onCancel, isTinhMienGiam }) => {
    const { dm_coso_id, nam_hoc } = useCommonSelectedHook();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [khoanNopGroups, setKhoanNopGroups] = useState<IKhoanNopGroup[]>([]);
    const [saleSetRegisterTypes, setSaleSetRegisterTypes] = useState<ISaleSetRegisterType[]>([]);
    const [saleSetKhoanNopGroupTypes, setSaleSetKhoanNopGroupTypes] = useState<ISaleSetKhoanNopGroupType[]>([]);
    const [listMienGiam, setListMienGiam] = useState<MienGiamItem[]>([]);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [khoanNopGroupHocSinhs, setKhoanNopGroupHocSinhs] = useState<
        KhoanNopByHocSinhItemResponse[]
    >([]);
    useEffect(() => {
        handleReloadKhoanNopGroups();
        handleReloadSaleSetRegisterTypes();
        handleReloadKhoanNopGroupTypes();
        handleReloadKhoanNopGroupHocSinhs();
    }, []);
    useEffect(() => {
        if (khoanNopGroupHocSinhs) {
            const checkedGroupIds = khoanNopGroupHocSinhs
                .filter(item => item.is_checked)
                .map(item => item.sf_khoannop_group_id);

            if (khoanNopGroups && checkedGroupIds.length > 0) {
                const filteredGroups = khoanNopGroups.filter(group =>
                    checkedGroupIds.includes(group.id) || group.ten_khoan_nop_group == 'Học phí'
                );
                setKhoanNopGroups(filteredGroups)
            }
        }
    }, [khoanNopGroupHocSinhs, khoanNopGroups]);

    const handleReloadKhoanNopGroups = async () => {
        setIsLoading(true);
        const res = await khoanNopGroupApi.SelectAll();
        if (res.is_success) {
            setKhoanNopGroups(res.data);
        } else {
            setKhoanNopGroups([]);
        }
        setIsLoading(false);

    };
    const handleReloadKhoanNopGroupHocSinhs = async () => {
        setIsLoading(true);
        const res = await khoanNopGroupApi.SelectByHocSinh({
            ts_hocsinh_id: hocSinh.id,
            nam_hoc: nam_hoc,
            dm_coso_id,
        });
        if (res.is_success) {
            setKhoanNopGroupHocSinhs(res.data);
        } else {
            setKhoanNopGroupHocSinhs([]);
        }
        setIsLoading(false);

    };

    const handleReloadSaleSetRegisterTypes = async () => {
        setIsLoading(true);
        const res = await saleSetRegisterTypeApi.selectAll();
        if (res.is_success) {
            setSaleSetRegisterTypes(res.data);
        } else {
            setSaleSetRegisterTypes([])
        }
        setIsLoading(false);

    };
    const handleReloadKhoanNopGroupTypes = async () => {
        setIsLoading(true);
        const res = await khoanNopGroupTypeApi.selectAllByHocSinh(hocSinh.id, nam_hoc);
        if (res.is_success) {
            setSaleSetKhoanNopGroupTypes(res.data);
        } else {
            setSaleSetKhoanNopGroupTypes([]);
        }
        setIsLoading(false);

    };
    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: "ten_khoan_nop_group",
                header: "Khoản nộp",
                accessor: ''
            },
        ];
        const dynamicColumns = saleSetRegisterTypes.map((col) => ({
            id: col.id,
            header: col.name,
            accessor: 'register'

        }));

        return [...baseColumns, ...dynamicColumns];
    }, [saleSetRegisterTypes]);

    const data = useMemo(() => {
        const response = khoanNopGroups
            .filter((x) => x.dm_coso_id === dm_coso_id)
            .map((group) => {
                const dynamicValues = saleSetRegisterTypes.reduce((acc, type) => {
                    const exists = saleSetKhoanNopGroupTypes.some(
                        (record) =>
                            record.sf_khoannop_group_id === group.id &&
                            record.sf_saleset_register_type_id === type.id
                    );
                    acc[`${group.id}_${type.id}`] = exists;
                    return acc;
                }, {} as { [key: string]: boolean });

                return {
                    ...group,
                    ...dynamicValues,
                };
            });
        return response;
    }, [khoanNopGroups, saleSetRegisterTypes, saleSetKhoanNopGroupTypes, dm_coso_id]);

    const handleCheckboxChange = async (key: string) => {
        const keyParts = key.split("_");
        const [sf_khoannop_group_id, sf_saleset_register_type_id] = keyParts;
        const dataSend: ISaleSetKhoanNopGroupType = {
            id: 0,
            ts_hocsinh_id: hocSinh.id,
            nam_hoc: nam_hoc,
            sf_khoannop_group_id: parseInt(sf_khoannop_group_id),
            sf_saleset_register_type_id: parseInt(sf_saleset_register_type_id)
        };
        const res = await khoanNopGroupTypeApi.insert(dataSend);
        if (res.is_success) {
            handleReloadKhoanNopGroupTypes();
        }
    };
    const handleNextStep = () => {
        onSubmit(selectedIds.length > 0);
    }

    useEffect(() => {
        if (nam_hoc && hocSinh.id) {
            getListMienGiamByHocSinh();
            getListMienGiam();
        }
    }, [hocSinh.id]);

    const getListMienGiam = async () => {
        try {
            const res: ApiResponse<MienGiamItem[]> =
                await hinhThucMienGiamApi.selectAllByNamHoc(
                    nam_hoc,
                    hocSinh.id,
                    dm_coso_id
                );
            if (res.is_success && res.data) {
                setListMienGiam(res.data);
            } else {
                setListMienGiam([]);
            }
        } catch (error) {
            console.error("Error fetching mien giam list:", error);
            setListMienGiam([]);
        }
    };

    const getListMienGiamByHocSinh = async () => {
        try {
            const res: ApiResponse<MienGiamItem[]> =
                await hinhThucMienGiamApi.selectByHocSinh(nam_hoc, hocSinh.id);
            if (res.is_success && res.data) {
                const selectedMienGiamIds = res.data.map((item) => item.id);
                setSelectedIds(selectedMienGiamIds);
            }
        } catch (error) {
            console.error("Error fetching selected mien giam:", error);
        }
    };

    const handleCheckboxMienGiamChange = async (
        itemId: number,
        nhomMienGiam: string,
        checked: boolean
    ) => {
        // Xác định các items trong cùng nhóm với item đang chọn
        const itemsInSameGroup = listMienGiam
            .filter((item) => item.nhom_mien_giam === nhomMienGiam)
            .map((item) => item.id);

        setSelectedIds((prevSelectedIds) => {
            if (checked) {
                // Cập nhật selectedIds để chỉ có item hiện tại được chọn trong nhóm
                return prevSelectedIds
                    .filter((id) => !itemsInSameGroup.includes(id)) // Bỏ chọn các item trong cùng nhóm
                    .concat(itemId); // Thêm item hiện tại
            } else {
                // Nếu bỏ chọn, xóa item hiện tại khỏi danh sách
                return prevSelectedIds.filter((id) => id !== itemId);
            }
        });

        try {
            if (checked) {
                // Xóa tất cả các item đã chọn trong nhóm
                await hinhThucMienGiamApi.deleteDeXuatMienGiam({
                    id: hocSinh.id,
                    nam_hoc: nam_hoc,
                    sf_hinhthucmiengiam_ids: itemsInSameGroup,
                });

                // Thêm item mới được chọn
                await hinhThucMienGiamApi.insertDeXuatMienGiam({
                    id: hocSinh.id,
                    nam_hoc: nam_hoc,
                    sf_hinhthucmiengiam_ids: [itemId],
                });

                NotifyHelper.Success("Cập nhật thông tin thành công");
            } else {
                // Xóa item đã bỏ chọn
                await hinhThucMienGiamApi.deleteDeXuatMienGiam({
                    id: hocSinh.id,
                    nam_hoc: nam_hoc,
                    sf_hinhthucmiengiam_ids: [itemId],
                });

                NotifyHelper.Success("Xóa mục thành công");
            }
        } catch (error) {
            console.error("Error updating selection:", error);
            NotifyHelper.Error("Có lỗi xảy ra");
        }
    };
    const groupedMienGiam = useMemo(() => {
        return listMienGiam.reduce(
            (groups: { [key: string]: GroupedMienGiam }, current) => {
                const key = current.nhom_mien_giam.toString();
                if (!groups[key]) {
                    groups[key] = {
                        key,
                        items: [],
                    };
                }
                groups[key].items.push(current);
                return groups;
            },
            {}
        );
    }, [listMienGiam]);
    return (
        <Box
            sx={{
                border: '1px solid',
                borderColor: 'border.default',
                borderRadius: 2,
                maxHeight: 'calc(100vh - 250px)',
                overflowY: 'auto',
                p: 1,
            }}
        >
            <Box
                sx={{
                    borderBottom: '1px solid',
                    borderColor: 'border.default',
                    height: 'calc(90vh - 280px)',
                    overflowY: 'auto',
                }}
            >
                <Box sx={{
                    pt: 1, pb: 1, borderBottom: '1px solid',
                    borderColor: 'border.default',
                }}>
                    <Box sx={{ display: "flex", gap: 3 }}>
                        <Box sx={{ flex: 1 }}>

                            <table
                                style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    fontSize: "13px",
                                    tableLayout: "fixed",
                                }}
                            >
                                <thead>
                                    <tr>
                                        {columns.map((col) => (
                                            <th
                                                key={col.id}
                                                style={{
                                                    border: "1px solid #ddd",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    backgroundColor: "#f6f8fa",
                                                    ...(!col.accessor.startsWith("register")
                                                        ? { width: "50%" }
                                                        : {}),
                                                    // position: "sticky",
                                                    // top: 0,
                                                    // zIndex: 2
                                                }}
                                            >
                                                {col.header}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((row: any, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {columns.map((col) => (
                                                <td
                                                    key={row.id + '_' + col.id}
                                                    style={{
                                                        border: "1px solid #ddd",
                                                        padding: "8px",
                                                        textAlign: "left",
                                                        ...(col.accessor.startsWith("register")
                                                            ? { width: "200px", textAlign: "center" }
                                                            : {}),
                                                    }}
                                                >
                                                    {col.accessor.startsWith("register") ? (
                                                        <Box sx={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            height: "100%",
                                                            cursor: 'pointer',
                                                        }}>
                                                            <Checkbox
                                                                checked={row[row.id + '_' + col.id]}
                                                                onChange={() => handleCheckboxChange(`${row.id}_${col.id}`)}
                                                            />
                                                        </Box>
                                                    ) : (
                                                        row.ten_khoan_nop_group
                                                    )}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            {Object.values(groupedMienGiam).map((group) => (
                                <Box key={group.key}>
                                    <Box
                                        sx={{
                                            bg: "canvas.subtle",
                                            p: 2,
                                            border: "1px solid",
                                            borderColor: "border.default",
                                            fontWeight: "bold",
                                            color: "fg.muted",
                                        }}
                                    >
                                        Nhóm miễn giảm: {group.key}
                                    </Box >
                                    <Box
                                        sx={{
                                            border: "1px solid",
                                            borderColor: "border.default",
                                        }}
                                    >
                                        <ActionList>
                                            {group.items.map((item) => (
                                                <ActionList.Item
                                                    key={item.id}
                                                    style={
                                                        selectedIds.includes(item.id)
                                                            ? { opacity: 0.5, pointerEvents: "none" }
                                                            : {}
                                                    }
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <Checkbox
                                                            checked={selectedIds.includes(item.id)}
                                                            onChange={(
                                                                e: React.ChangeEvent<HTMLInputElement>
                                                            ) => {
                                                                handleCheckboxMienGiamChange(
                                                                    item.id,
                                                                    item.nhom_mien_giam,
                                                                    e.target.checked
                                                                );
                                                            }}
                                                        />
                                                        <Box sx={{ display: "flex", flex: 1, ml: 2 }}>
                                                            <Box sx={{ width: "30%", pr: 2 }}>
                                                                {item.ma_hinh_thuc}
                                                            </Box>
                                                            <Box sx={{ width: "70%" }}>
                                                                {item.hinh_thuc_mien_giam}
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </ActionList.Item>
                                            ))}
                                        </ActionList>
                                    </Box >

                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ mt: 2, mr: 1, display: "flex", justifyContent: "space-between" }}>
                <Button sx={{ ml: 1 }}
                    text='Thoát'
                    size='medium'
                    leadingVisual={SignInIcon}
                    onClick={onCancel}
                />
                <Button sx={{ mr: 1 }}
                    text="Tiếp tục"
                    trailingVisual={ArrowRightIcon}
                    variant="primary"
                    size="medium"
                    onClick={handleNextStep}
                />
            </Box>
        </Box>
    );
};

export default HinhThucNopPhi;